<!--  -->
<template>
  <div>
    <div class="table-top">
      <el-button v-if="!disabled" @click="addRow">添加一行</el-button>
    </div>
    <vxe-table border align="center" size="mini" :data="tableData" :edit-config="{ trigger: 'click', mode: 'row' }">
      <vxe-column align="center" title="序号" type="seq" width="60" />
      <vxe-column field="productCode" title="商品编码">
      </vxe-column>
      <vxe-column field="productName" title="商品名称">
      </vxe-column>
      <vxe-column field="originalIntegral" title="原积分">
      </vxe-column>
      <vxe-column field="nowIntegral" title="现积分">
            <template #default="{ row }">
        <el-input-number @change='changeEvent' v-model="row.nowIntegral" :min="0"></el-input-number>
        </template>

      </vxe-column>
      <vxe-column v-if="!disabled" title="操作" show-overflow width="80">
        <template #default="{ row }">
          <el-button type="danger" @click="removeEvent(row)" icon="el-icon-delete" circle></el-button>
        </template>
      </vxe-column>
    </vxe-table>
        <!-- 弹框 -->
    <SelectConfig ref="selectConfig" @onGetSelect="onGetSelect" />
  </div>
</template>

<script>
import SelectConfig from '@/found/components/select_org_cus_ter/select_config.vue';

export default {
  name: 'pointsProduct',
  components: {
    SelectConfig,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tableData: [],
    };
  },
  computed: {},
  created() {

  },
  mounted() { },
  methods: {
    onGetSelect(val) {
      const selectCode = this.tableData.map((item) => item.productCode);
      const selectData = (val || []).filter((item) => !selectCode.includes(item.productCode));
      this.tableData = this.tableData.concat(selectData.map((item) => ({
        ...item,
        originalIntegral: item.integral,
      })));
      this.changeEvent();
    },
    removeEvent(row) {
      this.tableData = this.tableData.filter((item) => item.id !== row.id);
      this.changeEvent();
    },
    addRow() {
      const params = {
        data: [],
        selectionList: [],
        functionCode: 'points_product',
        idKey: 'productCode',
        noReset: true,
        paramData: {
          enableStatus: '009',
          productType: '1',
        },
      };
      console.log(this.$refs);
      this.$refs.selectConfig.openSelectModal(params);
    },

    changeEvent() {
      this.$emit('change', this.tableData);
      this.$emit('input', this.tableData);
    },
  },
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler(val) {
        this.tableData = val
          ? val.map((el) => ({
            ...el,
            id: el.id || new Date().getTime() + Math.random() * 10000,
          }))
          : [];
      },
    },
  },
};
</script>

<style scoped lang="less">
.table-top {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  gap: 10px;
}

/deep/.vxe-header--column .vxe-cell--title {
  line-height: inherit !important;
}
</style>
